import profilePhoto from './assets/karan-soni-image.png'

const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: process.env.REACT_APP_PORTFOLIOURL,
  title: 'Hey!', // can be removed if we are using KS as the left header text
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Karan Soni',
  role: 'Software Developer',
  description:
    "Highly Motivated toward my goal and eager to contribute my knowledge to the industry and improve myself for the better future of the company and myself.",
  // Place resume file inside public/assets and keep this path in sync
  resume: '/assets/karan-soni-resume.pdf',
  // Photo is imported from src/assets for optimization
  photo: profilePhoto,
  social: {
    linkedin: 'https://www.linkedin.com/in/karanssoni/',
    github: 'https://github.com/krn1904',
  },
}

const experiences = [
  {
    title : 'Software Developer',
    company : 'Vision Verse Interactive - Cornven POS',
    startDate: 'February 2026',
    endDate: 'June 2026',
    description:
      'Extended a full-stack POS and rental-management platform from in-store operations into connected online selling for an artist cube store.',
    highlights: [
      'Integrated Shopify publishing, order/refund webhooks, sync logs, and inventory updates for online sales.',
      'Built Stripe subscription gating for Shopify access with admin controls and lifecycle notifications.',
      'Implemented product re-approval so live listings stay active while tenant edits await review.',
      'Improved inventory reliability across POS and Shopify with transactional updates and failure logging.',
      'Enhanced tenant and admin workflows for products, rentals, support messages, variants, and images.',
      'Owned deployment setup, backend server configuration, database reset/migration, and domain configuration.',
    ],
    details: [
      'Shopify', 'Stripe', 'React', 'TypeScript', 'Node.js', 'Express.js', 'PostgreSQL', 
    ]
  },
  {
  title : 'Associate Engineer',
  company : 'Cygnet Digital',
  startDate: 'September 2023',
  endDate: 'July 2024',
  description:
    "Scaled a Vue.js GST taxation platform for enterprise compliance while modernising the front-end stack.",
  highlights: [
    'Extended the Vue.js GST compliance platform for enterprise filers, hardening high-volume workflows and accessibility.',
    'Built a library of reusable Vue 3 components and composables, shrinking duplicate code across feature squads.',
    'Implemented GST reporting modules with Vuex state, Axios-powered REST integrations, and real-time ledger updates.',
    'Delivered a responsive homepage redesign with product and design, tuning layout performance and UI polish.',
    'Co-led the migration from Vue 2 to Vue 3 on Vite, pairing rollout with structured defect triage to keep releases stable.',
  ],
  details: [
    'Vue.js', 'Vuex', 'TypeScript', 'Vite', 'REST APIs', 'Component Systems'
  ]
},
{
  title : 'Software Developer',
  company : 'Knackroot Technolabs LLP',
  startDate: 'January 2023',
  endDate: 'June 2023',
  description:
    'Led full-stack delivery of a blockchain-based crypto earnings platform across web and mobile.',
  highlights: [
    'Managed the development of a blockchain-powered crypto earnings application.',
    'Designed RESTful APIs and relational schemas with Node.js and PostgreSQL to support secure transactions.',
    'Produced and deployed React Native builds for both Android and iOS ecosystems.',
    'Partnered with designers, QA, and product stakeholders to refine features iteratively.',
    'Owned deployment workflows and maintenance, safeguarding scalability in a fast-paced release cycle.',
    'Conducted targeted testing and debugging sessions to elevate overall reliability.',
  ],
  details: [
    'React', 'React Native', 'Node.js', 'PostgreSQL', 'REST APIs', 'Blockchain'
  ]
}
]

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  // {
  //   name: 'Orbitium',
  //   description:
  //     'Orbitium is a Blockchain based crypto earning Application. You can earn from the Day one of registration. There are multiple',
  //   stack: ['Postgres', 'TypeScript', 'React', 'NodeJs', 'TypeORM', 'Blockchain'],
  // },
  // {
  //   name: 'Tic-Tac-toe',
  //   description:
  //     "Built in Java using Android Studio, my project is a classic Tic-Tac-Toe game. It's a two-player game designed for fun and entertainment.",
  //   stack: [ 'Java', 'Android-Studio'],
  //   sourceCode: 'https://github.com/krn1904/Tic-Tac-Toe',
  //   // livePreview: 'https://github.com',
  // },
  // removed project as it is not completed and not have any preeview. Think to add later when completed
  // {
  //   name: 'Book-E-Sell',
  //   description:
  //     "Introducing 'Book-e-Sell,' a library management project that brings all available books to one convenient platform.",
  //   stack: [ 'React','Nodejs','mongoDb'],
  //   sourceCode: 'https://github.com/krn1904/Book-management',
  //   // livePreview: 'https://github.com',
  // },

  // removing as no need to show basic projects and not able to preview as well!
  // {
  //   name: 'Currency Converter',
  //   description:
  //     'Explore the Currency Converter project, a tool that simplifies currency conversion for a specific set of currencies',
  //   stack: ['Android-Studio', 'Java'],
  //   sourceCode: 'https://github.com/krn1904/CurrencyConverter', 
  //   // livePreview: 'https://github.com',
  // },
  // {
  //   name: 'TextUtils',
  //   description:
  //     'TextUtils: Your ultimate text companion. A versatile tool offering text analysis, word counting, and conversion capabilities."',
  //   stack: ['JavaScript', 'HTML', 'CSS'],
  //   sourceCode: "https://github.com/krn1904/textutils",
  //   livePreview: process.env.REACT_APP_TEXTUTILSURL
  // },
  {
    name: 'ShelfLife - Retail Expiry Tracking',
    description:
      'Multi-tenant back-of-house platform for convenience retail that stops stock expiring unnoticed. Staff photograph the delivery docket and OCR turns it into intake lines matched to the supplier and catalogue. A nightly Edge Function on pg_cron generates half-price and last-day reminders from each batch\'s shelf life. Four roles are isolated with Postgres row-level security, verified by an automated cross-organisation test in CI.',
    stack: ['Next.js', 'React', 'TypeScript', 'Supabase', 'PostgreSQL', 'Tailwind CSS', 'AWS Textract', 'GitHub Actions'],
    sourceCode: 'https://github.com/krn1904/shelflife',
    livePreview: process.env.REACT_APP_SHELFLIFEURL
  },
  {
    name: 'Persona Chatbot - Chat With Your Documents',
    description:
      'Persona-driven RAG chatbot that answers questions from your own documents and cites its sources. Each persona (tutor, code reviewer, interview coach) is a swappable prompt file with its own knowledge base, chunked and embedded into a Chroma vector index. Users can upload PDFs or text files for the session, which take priority over the persona\'s built-in documents. Guardrails fall back to "I don\'t know" when nothing relevant is found and treat uploaded files as data, not instructions. One shared engine powers both a command-line tool and a Streamlit web app on Gemini\'s free tier.',
    stack: ['Python', 'Gemini AI', 'RAG', 'ChromaDB', 'Embeddings', 'Streamlit'],
    sourceCode: 'https://github.com/krn1904/AI-chatbot-personas',
    livePreview: process.env.REACT_APP_PERSONACHATBOTURL
  },
  {
    name: 'Brief - Personalized News',
    description:
      'Personalized, multi-source news aggregator that collects, cleans, deduplicates, clusters, and tags stories from RSS and different news sources. Uses Gemini AI for topic tagging and on-demand article summaries, with cached summaries shared across signed-in users. Learns from each user vote to update topic interests and rank a fresh, diverse feed by interest, freshness, and source variety.',
    stack: ['Next.js', 'TypeScript', 'PostgreSQL', 'Drizzle ORM', 'NextAuth', 'Gemini AI', 'GitHub Actions'],
    sourceCode: 'https://github.com/krn1904/News-Aggregator',
    livePreview: process.env.REACT_APP_BRIEFURL
  },
  {
    name: 'Artify - Custom Artwork Marketplace',
    description:
      'Full-stack marketplace platform enabling artists to showcase portfolios and customers to commission custom artwork. Implements role-based authentication, paginated artwork browsing with tag filtering, favorites system, and complete commission lifecycle management from request to completion with status notifications.',
    stack: ['Next.js', 'TypeScript', 'MongoDB', 'NextAuth', 'React Hook Form', 'Zod', 'Radix UI'],
    sourceCode: 'https://github.com/krn1904/artify',
    livePreview: process.env.REACT_APP_ARTIFYURL
  },
  {
    name: 'Real-Time Chat Application',
    description:
      'Full-stack WebSocket chat app with room-based messaging, live connection status, and session-based message history. Features React frontend with custom hooks for connection management, Node.js/Express backend with WebSocket server, and automatic reconnection with message queuing.',
    stack: ['React', 'Node.js', 'Express', 'WebSocket', 'MongoDB', 'Bootstrap'],
    sourceCode: 'https://github.com/krn1904/Chat-app',
    livePreview: process.env.REACT_APP_CHATAPPFEURL
  },
  {
    name: 'Work Hours Bot',
    description:
      'A Telegram bot for tracking work hours with natural language parsing. Supports bi-weekly pay cycles, category tracking, pay rate calculations, and automated daily reminders. Built for serverless deployment on Vercel with MongoDB backend.',
    stack: ['Node.js', 'MongoDB', 'Telegram Bot API', 'Vercel', 'GitHub Actions'],
    sourceCode: 'https://github.com/krn1904/workHoursBot',
    // livePreview: process.env.TELEGRAM_BOT_USERNAME || '@your_work_hours_bot'
  },
  {
    name: 'Music Subscription Platform - AWS',
    description:
      'A music subscription REST API deployed across three AWS architectures - EC2 (Nginx + PM2), ECS Fargate (Docker + ALB), and Lambda + API Gateway — covering IaaS, containerised, and serverless models. Features DynamoDB schema with composite sort keys, GSI and LSI, IAM least-privilege roles, and presigned URL access for private S3 assets.',
    stack: ['React', 'Node.js', 'DynamoDB', 'S3', 'EC2', 'ECS Fargate', 'Lambda', 'Docker', 'AWS IAM'],
    sourceCode: 'https://github.com/krn1904/music-backend',
    // livePreview: 'your-deployed-url-here'
  }
]

const skills = [
  {
    category: 'Languages & Frameworks',
    sections: [
      {
        label: 'Languages',
        items: ['JavaScript', 'TypeScript', 'Java', 'Python'],
      },
      {
        label: 'Frameworks',
        items: ['React', 'Vue.js', 'Next.js', 'Node.js', 'Express.js', 'Vite', 'React Native', 'Bootstrap'],
      },
    ],
  },
  {
    category: 'Data & Infrastructure',
    sections: [
      {
        label: 'Database',
        items: ['PostgreSQL', 'MongoDB', 'DynamoDB', 'Drizzle ORM'],
      },
      {
        label: 'Cloud & DevOps',
        items: ['AWS', 'S3', 'ECS Fargate', 'EC2', 'ECR', 'Docker', 'Vercel', 'Render', 'GitHub Actions'],
      },
    ],
  },
  {
    category: 'APIs & Tools',
    sections: [
      {
        label: 'APIs, Auth & Payments',
        items: ['REST APIs', 'WebSockets', 'JWT', 'NextAuth', 'Stripe', 'Shopify'],
      },
      {
        label: 'Tools',
        items: ['Git', 'GitHub', 'Sourcetree'],
      },
    ],
  },
  {
    category: 'AI & Tooling',
    sections: [
      {
        label: 'AI Tools',
        items: ['Gemini AI', 'Cursor', 'Claude', 'ChatGPT', 'GitHub Copilot'],
      },
      {
        label: 'AI Coding Agents',
        items: ['Claude Code', 'Codex'],
      },
    ],
  },
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'Karanssoni2002@gmail.com',
}

export { header, about, experiences, projects, skills, contact }
